export enum PropertyType {
	House = 'House',
	Appartment = 'Appartment',
	HolidayHome = 'HolidayHome',
	ParentPurchase = 'ParentPurchase',
	DecommissionedFarm = 'DecommissionedFarm',
	LivingAtHome = 'LivingAtHome',
	Rental = 'Rental',
}
